import {
  Component,
  OnInit,
  OnChanges,
  ErrorHandler,
  HostListener,
  ComponentFactoryResolver,
} from "@angular/core";
import { Observable, throwError } from "rxjs";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { AngularFirestore, QuerySnapshot } from "angularfire2/firestore";
import * as firebase from 'firebase';

import * as confetti from "canvas-confetti";

// Set the http options
const httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json",
    Authorization:
      "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7InVzZXJuYW1lIjoibXRnZXZlbnRzX2FwcCIsInN1YmNyaXB0aW9uS2V5IjoiYzJkOGJkMDQtMGY0Yy00N2FlLWI4NjAtMzBlODM1MTRjYmQ3In0sImlhdCI6MTU2NDQ2ODE3OX0.VjiFlZInzMnQeRxOlRmNg-7EZ97L1giBwo3Nbu8PL_M",
  }),
};

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  title = "n00bcoM";

  public reportedMatchesFilteredRound = null;
  public showReportTable: boolean = false;
  public resultSlip = {
    reporterWon: false,
    opponentWon: false,
    reporterGW: null,
    opponentGW: null,
    gamesDrawn: null,
    isReportedWithApp: false,
    round: null
  }

  resetSlip() {
    this.resultSlip.reporterWon = false;
    this.resultSlip.opponentWon = false;
    this.resultSlip.reporterGW = null;
    this.resultSlip.opponentGW = null;
    this.resultSlip.gamesDrawn = null;
    this.reportTable = null;
    this.resultSlip.isReportedWithApp = false
  }

  public displayName = "";
  public chatMessage = "";
  public chatMessages: Observable<any[]>;
  public chatMinimized = true;
  public chatColor: string;
  public chatAnnouncement: boolean = false;
  public bingoAnnouncement: boolean = false;
  public secretCode: string = "";
  public isReporting: boolean = false;
  public reportTable: number;
  public reportResult: string = "";
  public adminMode = false;
  public timeMinimized = true;
  public bracketSelected: boolean = false;
  public showChatMessages: boolean = true;
  public showMatchReports: boolean = true;
  public showAnnouncements: boolean = true;
  public showBingoAnnouncements: boolean = true;
  public muteChat: boolean = false;

  public showHowto: boolean = false;
  public howtos = [
    {
      title: "Report Match Result",
      steps: [
        "Open up the chat panel by pressing the chat icon to the left of the screen",
        "Click report button in chat area",
        "Enter the table number you played at (according to pairings) in the table number input field",
        "Enter the result in the result input (games won by you - games won by your opponent - games drawn). Note that you have to enter ALL variables to be allowed to post the result. Intentional draws are reported as 0-0-3",
      ],
      gif: "assets/howto-report-match-result.gif",
    },
    {
      title: "Send Chat Message",
      steps: [
        "Open up the chat panel by pressing the chat icon to the left of the screen",
        "Enter your name in the name input (this will be store in you local storage and loaded if you refresh the page)",
        "Write you message in the message area",
        "Click the send button or hit ENTER on your keyboard",
      ],
      gif: "assets/howto-send-chat-message.gif",
    },
  ];

  public happeningTitle: string = "";
  public happeningText: string = "";
  public happeningTimeStart: string = "";
  public happeningTimeEnd: string = "";
  public happenings: Observable<any[]>;

  isBusy = true;
  eventDetails: any;
  rounds = [];
  roundData: any = {
    round: 0,
    matches: [],
    unpairedPlayers: [],
    status: "No round selected",
  };
  showData = false;
  showPairings = true;
  standingsSelected = false;
  selectedRound = 0;
  filterText: string = "";
  standingsData: any;

  colors = [
    "yellow",
    "orange",
    "blue",
    "red",
    "greenyellow",
    "pink",
    "teal",
    "moccasin",
    "lightsalmon",
    "paleturquoise",
  ];

  private lastChatMessage: string = "";

  eventNumber: string = "001256";
  tableUrls = [
    "",
    "https://n00bcom.whereby.com/table01?widescreen",
    "https://n00bcom.whereby.com/table02?widescreen",
    "https://n00bcom.whereby.com/table03?widescreen",
    "https://n00bcom.whereby.com/table04?widescreen",
    "https://n00bcom.whereby.com/table05?widescreen",
    "https://n00bcom.whereby.com/table06?widescreen",
    "https://n00bcom.whereby.com/table07?widescreen",
    "https://n00bcom.whereby.com/table08?widescreen",
    "https://n00bcom.whereby.com/table09?widescreen",
    "https://n00bcom.whereby.com/table10?widescreen",
    "https://n00bcom.whereby.com/table11?widescreen",
    "https://n00bcom.whereby.com/table12?widescreen",
    "https://n00bcom.whereby.com/table13?widescreen",
    "https://n00bcom.whereby.com/table14?widescreen",
    "https://n00bcom.whereby.com/table15?widescreen",
    "https://n00bcom.whereby.com/table16?widescreen",
    "https://n00bcom.whereby.com/table17?widescreen",
    "https://n00bcom.whereby.com/table18?widescreen",
    "https://n00bcom.whereby.com/table19?widescreen",
    "https://n00bcom.whereby.com/table20?widescreen",
    "https://n00bcom.whereby.com/table21?widescreen",
    "https://n00bcom.whereby.com/table22?widescreen",
    "https://n00bcom.whereby.com/table23?widescreen",
    "https://n00bcom.whereby.com/table24?widescreen",
    "https://n00bcom.whereby.com/table25?widescreen",
    "https://n00bcom.whereby.com/table26?widescreen",
    "https://n00bcom.whereby.com/table27?widescreen",
    "https://n00bcom.whereby.com/table28?widescreen",
    "https://n00bcom.whereby.com/table29?widescreen",
    "https://n00bcom.whereby.com/table30?widescreen",
    "https://n00bcom.whereby.com/table31?widescreen",
    "https://n00bcom.whereby.com/table32?widescreen",
    "https://n00bcom.whereby.com/table33?widescreen",
    "https://n00bcom.whereby.com/table34?widescreen",
    "https://n00bcom.whereby.com/table35?widescreen",
    "https://n00bcom.whereby.com/table36?widescreen",
    "https://n00bcom.whereby.com/table37?widescreen",
    "https://n00bcom.whereby.com/table38?widescreen",
    "https://n00bcom.whereby.com/table39?widescreen",
    "https://n00bcom.whereby.com/table40?widescreen",
    "https://n00bcom.whereby.com/table41?widescreen",
    "https://n00bcom.whereby.com/table42?widescreen",
    "https://n00bcom.whereby.com/table43?widescreen",
    "https://n00bcom.whereby.com/table44?widescreen",
    "https://n00bcom.whereby.com/table45?widescreen",
    "https://n00bcom.whereby.com/table46?widescreen",
    "https://n00bcom.whereby.com/table47?widescreen",
    "https://n00bcom.whereby.com/table48?widescreen",
    "https://n00bcom.whereby.com/table49?widescreen",
    "https://n00bcom.whereby.com/table50?widescreen",
  ];

  // canvas for confetti
  // public canvas: HTMLCanvasElement;
  constructor(private http: HttpClient, private db: AngularFirestore) {
    this.chatMessages = db
      .collection("/chat", (ref) => ref.orderBy("timestamp", "asc"))
      .valueChanges();

    this.happenings = this.db
      .collection("/happenings", (ref) => ref.orderBy("start", "asc"))
      .valueChanges();
  }
  ngOnInit() {
    // this.confettiRain();

    console.log("Checking for stored color code");
    if (localStorage.getItem("chatColor")) {
      console.log(
        "... color code found. (" + localStorage.getItem("chatColor") + ")"
      );
      this.chatColor = localStorage.getItem("chatColor");
    } else {
      console.log("... no color found, setting one.");
      localStorage.setItem(
        "chatColor",
        this.colors[Math.floor(Math.random() * 10)]
      );
      this.chatColor = localStorage.getItem("chatColor");
      console.log("... color code set (" + this.chatColor + ")");
    }
    console.log("Checking for store display name");
    if (localStorage.getItem("displayName")) {
      console.log("... name found, setting it in the chat");
      this.displayName = localStorage.getItem("displayName");
    }

    this.chatMessages.subscribe((data) => {
      console.log("new message");
      let lastIndex = data.length - 1;
      let lastMessage = data[lastIndex];
      console.log(lastMessage);
      if (this.lastChatMessage != lastMessage.message) {
        this.lastChatMessage = lastMessage.message;
        if (lastMessage.type === "announcement") {
          this.chatMinimized = false;
          var audio = new Audio("assets/new-announcement-chat.wav");
          audio.play();
        }
        if (lastMessage.type === "normal") {
          var audio = new Audio("assets/new-normal-chat.wav");
          if (!this.muteChat) { audio.play(); }
        }
        if (lastMessage.type === "match-result") {
          var audio = new Audio("assets/new-match-result-chat.wav");
          audio.play();
          // this.confettiRain();
        }
        if (lastMessage.type === "new-bingo-card") {
          this.chatMinimized = false;
          var audio = new Audio("assets/new-bingo-card.wav");
          audio.play();
        }
      } else {
        console.log("Duplicate message announcement, supress the sound");
      }
    });
    console.log("NG Init");
    this.getEventData().then((data: any) => {
      this.eventDetails = data;
      console.log("Event data: ", this.eventDetails);
      for (let i = 1; i <= this.eventDetails.roundsToPlay; i++) {
        let round = {
          num: i,
          selected: false,
        };
        if (i === this.eventDetails.status.activeRound) {
          console.log("Active Round: ", this.eventDetails.status.activeRound);

          round.selected = true;
          this.selectedRound = i;
          this.updateRoundData();
        }
        this.rounds.push(round);
      }
      this.isBusy = false;
    });

    setInterval(() => {
      this.getEventData().then((data: any) => {
        this.eventDetails = data;
      });
    }, 10000);
  }
  getEventData() {
    return new Promise((resolve, reject) => {
      this.http
        .get<any>("https://api.mtgevents.app/events/" + this.eventNumber, {
          headers: httpOptions.headers,
        })
        .subscribe((data) => {
          console.log("updated event data");
          resolve(data.eventData);
        });
    });
  }
  deselectAll() {
    this.rounds.forEach((round) => {
      round.selected = false;
    });
    this.standingsSelected = false;
    this.bracketSelected = false;
  }
  updateRoundData() {
    if (this.standingsSelected) {
      this.showData = true;
      this.standingsData = JSON.parse(
        JSON.stringify(this.eventDetails.players)
      );
      this.standingsData.sort((a, b) =>
        a.stats.ogwp > b.stats.ogwp ? -1 : b.stats.ogwp > a.stats.ogwp ? 1 : 0
      );
      this.standingsData.sort((a, b) =>
        a.stats.gwp > b.stats.gwp ? -1 : b.stats.gwp > a.stats.gwp ? 1 : 0
      );
      this.standingsData.sort((a, b) =>
        a.stats.omwp > b.stats.omwp ? -1 : b.stats.omwp > a.stats.omwp ? 1 : 0
      );
      this.standingsData.sort((a, b) =>
        a.stats.mp > b.stats.mp ? -1 : b.stats.mp > a.stats.mp ? 1 : 0
      );

      let rank = 1;
      this.standingsData.forEach((player) => {
        player.rank = rank;
        rank++;
      });
    } else {
      console.log("selected round index:", this.selectedRound);
      console.log(
        "event status:",
        this.eventDetails.status.text +
          " (" +
          this.eventDetails.status.code +
          ")"
      );
      if (
        this.eventDetails.round.findIndex(
          (x) => x.round === this.selectedRound
        ) === -1
      ) {
        console.log("... no round data, hide table and show message instead");
        this.showData = false;
      } else if (
        this.eventDetails.status.activeRound === this.selectedRound &&
        this.eventDetails.status.code < 2
      ) {
        console.log(
          "... active round is not paired, hide table and show message instead"
        );
        this.showData = false;
      } else {
        this.showData = true;
        this.roundData = JSON.parse(
          JSON.stringify(
            this.eventDetails.round[
              this.eventDetails.round.findIndex(
                (x) => x.round === this.selectedRound
              )
            ]
          )
        );
        // console.log("round data", this.roundData);
      }
    }
  }
  getPercentage = function (value) {
    let newValue = value * 100;
    return newValue.toFixed(2) + "%";
  };
  onKeysdown(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      this.sendChatMessage();
      this.chatMessage = "";
    }
  }
  sendChatMessage() {
    console.log("About to send message");
    if (
      (!this.isReporting && this.displayName.length > 0) ||
      (this.isReporting && this.newReportFormValid())
    ) {
      if (
        (!this.isReporting && this.chatMessage.length > 0) ||
        (this.isReporting && this.newReportFormValid())
      ) {
        localStorage.setItem("displayName", this.displayName);
        // let timestamp = new Date().getTime();
        const timestamp = firebase.firestore.FieldValue.serverTimestamp;
        let data: any = {
          message: this.chatMessage,
          type: "normal",
          displayName: this.displayName,
          displayColor: this.chatColor,
          timestamp: timestamp(),
        };
        if (this.chatAnnouncement) {
          data.type = "announcement";
        }
        if (this.bingoAnnouncement) {
          data.type = "bingo";
        }
        if (this.isReporting) {
          data.type = "match-result";
          // data.result = this.reportResult;
          data.result = this.resultSlip;
          data.table = this.reportTable;
          data.round = this.eventDetails.status.activeRound;
        }
        console.log("send message to firebase");
        this.db
          .collection("chat")
          .add(data)
          .then((response) => {
            this.db
              .collection("chat")
              .doc(response.id)
              .update({ docId: response.id });
            this.chatAnnouncement = false;
            this.bingoAnnouncement = false;
            this.chatMessage = "";
            this.isReporting = false;
            this.reportResult = "";
            this.reportTable = undefined;
            this.resetSlip();
          });
      }
    } else {
      console.log("... isReporting: ", this.isReporting);
      console.log("... formValid: ", this.reportFormValid());
      console.log("... displayName: ", this.displayName);
      console.log("... message: ", this.chatMessage);
    }
  }
  @HostListener("document:keypress", ["$event"])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === " ") {
      this.secretCode = "";
    } else {
      this.secretCode = this.secretCode + event.key;
      if (this.secretCode === "guardian") {
        this.adminMode = true;
      }
    }
  }
  reportFormValid() {
    const regex = /[1-2][-][0-1][-][\d]/gm;
    if (
      this.reportTable > 0 &&
      regex.exec(this.reportResult) &&
      this.reportResult.length === 5
    ) {
      console.log("form valid");
      return true;
    } else {
      console.log("form invalid");
      console.log("table: ", this.reportTable);
      console.log("regex: ", regex.exec(this.reportResult));
      return false;
    }
  }
  newReportFormValid() {
    if (this.resultSlip.reporterWon === false && this.resultSlip.opponentWon === false) {
      console.log("select a winner");
      return false;
    }
    if (this.resultSlip.reporterGW === 2 && this.resultSlip.opponentGW === 2) {
      console.log("both players cant win 2");
      return false;
    }
    if (this.resultSlip.reporterGW === null || this.resultSlip.opponentGW === null) {
      console.log("Both players need gw");
      return false;
    }
    if (this.reportTable < 1 || this.reportTable > 50) {
      console.log("report table below 1");
      return false;
    }

    return true;

  }
  addHappening() {
    let data = {
      title: this.happeningTitle,
      text: this.happeningText,
      start: this.happeningTimeStart,
      end: this.happeningTimeEnd,
    };
    this.db
      .collection("happenings")
      .add(data)
      .then((response) => {
        this.db
          .collection("happenings")
          .doc(response.id)
          .update({ docId: response.id });
        this.happeningTitle = "";
        this.happeningText = "";
        this.happeningTimeStart = "";
        this.happeningTimeEnd = "";
      });
  }
  deleteHappening(id) {
    this.db.collection("happenings").doc(id).delete();
  }
  deleteChatMessage(id) {
    this.db.collection("chat").doc(id).delete();
  }
  bingoAnnouncementToggle(bingoAnnouncement) {
    console.log(bingoAnnouncement);
  }
  markAsReported(docId) {
    this.db.collection("chat").doc(docId).update({ "result.isReportedWithApp": true}).then(response => {
      console.log(response);
    });
  } 

  fireConfetti(particleRatio, opts) {
    
    
  }
  // confettiRain() {
  //   let that = this;
  //   const count = 200;
  //   const defaults = {
  //     origin: { 
  //       y: 1,
  //       x: 1
  //     }
  //   };
  //   console.log("Confetti Rain!");
  //   function fire(particleRatio, opts) {
  //     confetti.create(that.canvas)(
  //     Object.assign({}, defaults, opts, {
  //       particleCount: Math.floor(count * particleRatio),
  //     })
  //   );
  //   }

  //   fire(0.25, {
  //     spread: 26,
  //     startVelocity: 55,
  //   });
  //   fire(0.2, {
  //     spread: 60,
  //   });
  //   fire(0.35, {
  //     spread: 100,
  //     decay: 0.91,
  //   });
  //   fire(0.1, {
  //     spread: 120,
  //     startVelocity: 25,
  //     decay: 0.92,
  //   });
  //   fire(0.1, {
  //     spread: 120,
  //     startVelocity: 45,
  //   });
  // }
}
